import { apiClient } from '@/api/api'
import type { AxiosResponse } from 'axios'
import type { ClaimProfileRewardResponse, UserProfileDataResponse } from '@/types/profile-data'

export const getUserProfileData = (): Promise<AxiosResponse<UserProfileDataResponse>> => {
  return apiClient.get<UserProfileDataResponse>('/user-profile/profile-data')
}

/** BE-132 — claims the reward of a reached level; 404 unknown / not reached, 409 already claimed. */
export const claimProfileReward = (level: string): Promise<AxiosResponse<ClaimProfileRewardResponse>> => {
  return apiClient.post<ClaimProfileRewardResponse>(`/user-profile/rewards/${encodeURIComponent(level)}/claim`)
}
